import { renderPagination } from '../../../components/Pagination/pagination.js';

(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {

    const block = document.querySelector('.provider-cards');
    if (!block) return;


    //////////////////////////////////////
    // DOM REFS
    const searchInput     = block.querySelector('.search input');
    const communitySelect = block.querySelector('.community-filter select');
    const serviceSelect   = block.querySelector('.service-filter select');
    const acceptingChk    = block.querySelector('.accepting-filter input[type="checkbox"]');
    const resetBtn        = block.querySelector('.reset');
    const cardsGrid       = block.querySelector('.cards-grid');
    const countEl         = block.querySelector('.count');
    const activeFilters   = block.querySelector('.active-filters');
    const paginationEl    = block.querySelector('.pagination');


    //////////////////////////////////////
    // DATA
    // Build an index from the rendered cards. One source of truth: the DOM.
    const perPage = parseInt(block.dataset.perPage, 10) || 18;
    const cardEls = Array.from(cardsGrid.querySelectorAll('.card-provider'));

    const parseIdList = (raw) => (raw || '')
      .split(',')
      .map((s) => parseInt(s, 10))
      .filter((n) => !Number.isNaN(n));

    const cards = cardEls.map((el) => ({
      el,
      search:      el.dataset.search      || '',
      communities: parseIdList(el.dataset.communities),
      services:    parseIdList(el.dataset.services),
      accepting:   el.dataset.accepting   === '1',
    }));


    //////////////////////////////////////
    // STATE
    const state = {
      search:    '',
      community: '',
      service:   '',
      accepting: false,
      page:      1,
    };


    //////////////////////////////////////
    // HELPERS
    const escHtml = (str) => String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');


    //////////////////////////////////////
    // FILTER
    const matchesFilters = (card) => {
      if (state.search && !card.search.includes(state.search.toLowerCase())) return false;
      if (state.community && !card.communities.includes(parseInt(state.community, 10))) return false;
      if (state.service   && !card.services.includes(parseInt(state.service, 10)))     return false;
      if (state.accepting && !card.accepting) return false;
      return true;
    };


    //////////////////////////////////////
    // RENDER
    const render = () => {
      const matched    = cards.filter(matchesFilters);
      const total      = matched.length;
      const totalPages = Math.max(1, Math.ceil(total / perPage));

      if (state.page > totalPages) state.page = totalPages;
      if (state.page < 1) state.page = 1;

      const start = (state.page - 1) * perPage;
      const end   = start + perPage;

      // Toggle visibility: matched cards within current page slice are shown, rest hidden.
      const visibleSet = new Set(matched.slice(start, end).map((c) => c.el));
      cards.forEach((c) => {
        if (visibleSet.has(c.el)) {
          c.el.removeAttribute('hidden');
        } else {
          c.el.setAttribute('hidden', '');
        }
      });

      countEl.textContent = `${total} provider${total !== 1 ? 's' : ''} found`;

      if (state.search) {
        activeFilters.innerHTML = `Showing results for <strong>${escHtml(state.search)}</strong>`;
        activeFilters.style.display = '';
      } else {
        activeFilters.style.display = 'none';
      }

      if (paginationEl) {
        renderPagination({
          container:   paginationEl,
          currentPage: state.page,
          totalItems:  total,
          perPage,
          label:       'Providers',
          onPageChange(page) { state.page = page; render(); }
        });
      }
    };


    //////////////////////////////////////
    // EVENTS
    let searchTimer;
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        state.search = searchInput.value.trim();
        state.page   = 1;
        render();
      }, 300);
    });

    communitySelect.addEventListener('change', () => {
      state.community = communitySelect.value;
      state.page      = 1;
      render();
    });

    serviceSelect.addEventListener('change', () => {
      state.service = serviceSelect.value;
      state.page    = 1;
      render();
    });

    acceptingChk.addEventListener('change', () => {
      state.accepting = acceptingChk.checked;
      state.page      = 1;
      render();
    });

    resetBtn.addEventListener('click', () => {
      state.search    = '';
      state.community = '';
      state.service   = '';
      state.accepting = false;
      state.page      = 1;
      searchInput.value     = '';
      communitySelect.value = '';
      serviceSelect.value   = '';
      acceptingChk.checked  = false;
      render();
    });


    //////////////////////////////////////
    // URL PARAM PRE-FILTER
    // Translate ?community_filter=slug / ?service_filter=slug into selected filter IDs
    const params = new URLSearchParams(window.location.search);
    const applyParamFilter = (paramName, select, stateKey) => {
      const slug = params.get(paramName);
      if (!slug) return false;
      const opt = select.querySelector(`option[data-slug="${CSS.escape(slug)}"]`);
      if (!opt) return false;
      state[stateKey] = opt.value;
      select.value    = opt.value;
      return true;
    };
    const filteredFromUrl =
      applyParamFilter('community_filter', communitySelect, 'community') |
      applyParamFilter('service_filter',   serviceSelect,   'service');


    //////////////////////////////////////
    // INIT
    // If a URL filter is active, re-render to apply it.
    // Otherwise the SSR'd first page is already correct — just render pagination.
    if (filteredFromUrl) {
      render();
    } else if (paginationEl) {
      renderPagination({
        container:   paginationEl,
        currentPage: 1,
        totalItems:  cards.length,
        perPage,
        label:       'Providers',
        onPageChange(page) { state.page = page; render(); }
      });
    }

  });

})();
